import strFunc from "@/lib/lyg/string";

function RowArea(props: any) {
  let myProps = {
    info: null,
    go_start_study: (inData: any) => { },
    ...props
  };

  let info = myProps.info;
  let word_cnt = 0;
  if (info.cg_word_arr) {
    word_cnt = strFunc.comma(info.cg_word_arr.length);
  }

  let title_str: any = "";
  if (info.inside_info) {
    title_str = info.inside_info.a_title;
  }

  let study_percent = 0;
  if (info.a_text_score) {
    study_percent = strFunc.uncomma_int(info.a_text_score);
  }

  return (
    <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 p-6 border border-gray-100">
      <div className="mb-4">
        <h3 className="text-lg font-bold text-gray-800 mb-2">{title_str}</h3>
        <div className="flex items-center gap-2">
          <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold ${info.a_word_type == "word"
            ? "bg-blue-100 text-blue-700"
            : "bg-purple-100 text-purple-700"
            }`}>
            {info.a_word_type == "word" ? "단어" : "문장"}
          </span>
          <span className="text-sm text-gray-600">
            {word_cnt}개
          </span>
        </div>
      </div>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-600 font-medium">
            학습 진행률
          </span>
          <span className={`px-3 py-1 rounded-full text-sm font-bold ${
            study_percent === 100
              ? "bg-green-100 text-green-700"
              : study_percent >= 70
              ? "bg-blue-100 text-blue-700"
              : study_percent >= 40
              ? "bg-yellow-100 text-yellow-700"
              : "bg-gray-100 text-gray-700"
          }`}>
            {study_percent}%
          </span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden">
          <div
            className={`h-full rounded-full transition-all duration-500 ${
              study_percent === 100
                ? "bg-gradient-to-r from-green-400 to-green-600"
                : study_percent >= 70
                ? "bg-gradient-to-r from-blue-400 to-blue-600"
                : study_percent >= 40
                ? "bg-gradient-to-r from-yellow-400 to-yellow-600"
                : "bg-gradient-to-r from-gray-400 to-gray-600"
            }`}
            style={{ width: `${study_percent}%` }}
          />
        </div>
        <div className="flex items-center justify-between text-xs text-gray-500">
          <span>성공: {info["a_amount"]}개</span>
          <span>전체: {info["a_success_amount"]}개</span>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-gray-100">
        <button className="w-full btn btn-sky hover:scale-105 transition-transform duration-200 p-4"
          onClick={() => {
            myProps.go_start_study({ info: info });
          }}
        >
          학습하기
        </button>
      </div>
    </div>
  );
};
export default RowArea;